// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1t9-m","anchor":"_2Il9P","tooltip":"_1Kle6","tooltipInner":"_2GF15","arrow":"_1fHVZ"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/common/Tooltip/styles.module.css
// module id = 220
// module chunks = 0